import client from './client'

export const whoAmI = () => client.get('users/whoami?include=providers')
